const doc = [({"da":({"js":({"admin":({"abilities":({"table":({"access":"Adgang"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;